<template>
  <div class="container-fluid">
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      has-return
    />
    <filter-manager
      ref="filterRef"
      class="search-bar"
      :display-advanced="false"
      search-text=""
      v-model="model.search.filters"
      :filters="filterManagerConfig"
    >
      <div class="col d-flex flex-column align-items-start justify-content-start my-1">
        <action-button
          id="process-additional-questions-egress"
          i="fa fa-sync"
          variant="success px-2 process-btn"
          type="button"
          @click="onHandlerSearch"
        >
          Procesar
        </action-button>
      </div>
    </filter-manager>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import ActionButton from 'ActionButton'
import reportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';
import academicYearServices from '@/services/api/academicyear.api';

export default {
  name: 'AdditionalQuestionsEgressProcess',
  components: {
    PageHeader,
    FilterManager,
    ActionButton,
  },
  data: () => ({
    model: {
      search: {
        filters: {
          academicYear: null,
        },
        collections: {
          academicYears: [],
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Preguntas Adicionales Proceso Egreso',
        icon: 'fa fa-file-invoice font-22',
        routes: ['Inicio', 'Informes Generales', 'Preguntas Adicionales Proceso Egreso'],
      };
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          class: 'col-md-3',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
        },
      ];
    },
  },
  async mounted() {
    await this.getInitialFilters();
  },
  methods: {
    async getInitialFilters() {
      const { data: _academicYears} = await academicYearServices.getCurrentYearAcademicYears();
      this.model.search.collections.academicYears = _academicYears;
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();

      if (!isValid) return;

      this.process();
    },
    async process() {
      const payload = { academicYearId: this.model.search.filters.academicYear?.id };
      const { data } = await reportServices.getReport('additionalquestionsegress', payload);
      DocumentServices.Download(data);
    },
  },
};
</script>
<style lang="scss" scoped>
.process-btn {
  margin-top: calc(0.5rem + 21px);
}
</style>
